import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type User } from '@webapp/platform/iam/entities/User'
import messages from './messages'
import { useMutateRevokeReportAccessFromAllPrimaryCategories } from '../../models/useMutateRevokeReportAccessFromAllPrimaryCategories'

export const useRevokeReportAccessFromAllPrimaryCategoriesPresenter = () => {
  const intl = useProcurifyIntl()
  const { revokeReportAccessFromAllPrimaryCategories, isRevoking } =
    useMutateRevokeReportAccessFromAllPrimaryCategories()

  /**
   * Tenant-wide bulk revoke (BHV-025 command side). Rejects after showing
   * the error toast. The danger dialog and reset-to-ADD are Feature Set
   * concerns.
   */
  const revokeFromAllPrimaryCategories = async (user: User): Promise<void> => {
    try {
      await revokeReportAccessFromAllPrimaryCategories({
        userId: user.id,
      })

      toast.success({
        title: intl.formatMessage(messages.successToastTitle),
        children: intl.formatMessage(messages.successToastMessage, {
          userFullName: user.fullName,
        }),
      })
    } catch (err) {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.errorToastDefaultMessage),
      })

      throw err
    }
  }

  return {
    commands: {
      revokeFromAllPrimaryCategories,
    },
    states: {
      isRevoking,
    },
  }
}
